import { FC, Fragment } from 'react';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import { Menu, Transition } from '@headlessui/react';
import { ReactComponent as Cursor } from '../../assets/icon/cursor_down.svg';
import { ReactComponent as CursorRight } from '../../assets/icon/cursor_right.svg';
import { ReactComponent as Guide } from '../../assets/icon/guide.svg';
import { ReactComponent as Mail } from '../../assets/icon/mail.svg';
import { ReactComponent as Member } from '../../assets/icon/member.svg';
import { ReactComponent as Tel } from '../../assets/icon/tel.svg';
import { mainCategories } from '../../constants/Categories';
import { scenes } from '../../constants/Scenes';
import { Collapse } from '../Collapse.client';
import { Link } from '../Link.client';

interface Props {
  isLogin: boolean;
}

export const MobileMenu: FC<Props> = ({ isLogin }) => (
  <Transition
    as={Fragment}
    enter="transition ease-out duration-100"
    enterFrom="transform opacity-0 scale-95"
    enterTo="transform opacity-100 scale-100"
    leave="transition ease-in duration-75"
    leaveFrom="transform opacity-100 scale-100"
    leaveTo="transform opacity-0 scale-95"
  >
    <Menu.Items className="absolute right-0 z-50 max-h-[calc(100vh-142px)] w-screen origin-top-right flex-col overflow-y-scroll bg-[#222] px-2 pt-5 pb-9 focus:outline-none">
      {!isLogin && (
        <div className="mb-5 grid grid-cols-2 gap-2">
          <Menu.Item>
            <Link route="login">
              <div className="flex items-center gap-3 bg-darkSkyBlue px-4 py-3">
                <Member width={24} height={24} fill="white" />
                <p className="text-[15px] text-white">ログイン</p>
              </div>
            </Link>
          </Menu.Item>
          <Menu.Item>
            <Link route="register">
              <div className="flex items-center gap-3 bg-darkSkyBlue px-4 py-3">
                <Member width={24} height={24} fill="white" />
                <p className="text-[15px] text-white">新規会員登録</p>
              </div>
            </Link>
          </Menu.Item>
        </div>
      )}
      <div className="mb-5">
        <Menu.Item>
          <Link route="guides">
            <div className="flex items-center justify-center gap-1 rounded-full bg-white py-1">
              <Guide width={18} height={18} />
              <p className="text-sm font-bold text-dark">ご利用ガイド</p>
            </div>
          </Link>
        </Menu.Item>
      </div>
      {/* <div className="mb-5">
        <Menu.Item>
          <Link route="ordermade">
            <div className="flex items-center justify-center gap-2">
              <p className="text-[15px] text-white">オーダー商品の作り方</p>
              <CursorRight width={12} height={12} fill="white" />
            </div>
          </Link>
        </Menu.Item>
      </div> */}
      <div className="mb-3 flex flex-col gap-[1px]">
        <Collapse
          header={(open) => (
            <div className="flex items-center justify-between border-b border-lightGray bg-thinGray px-4 py-3">
              <p className="text-[15px]">カテゴリから探す</p>
              <Cursor className={open ? 'rotate-180 transform' : ''} />
            </div>
          )}
        >
          <div className="grid grid-cols-2 gap-[1px]">
            {mainCategories.map((category, i) => (
              <Menu.Item key={i}>
                <Link route="category" handle={category}>
                  <div className="flex items-center justify-between bg-attention p-3">
                    <p className="truncate whitespace-nowrap text-sm">{category}</p>
                    <CursorRight width={12} height={12} fill="black" />
                  </div>
                </Link>
              </Menu.Item>
            ))}
          </div>
        </Collapse>
        <Collapse
          header={(open) => (
            <div className="flex items-center justify-between border-b border-lightGray bg-thinGray px-4 py-3">
              <p className="text-[15px]">シーンから探す</p>
              <Cursor className={open ? 'rotate-180 transform' : ''} />
            </div>
          )}
        >
          <div className="grid grid-cols-2 gap-[1px]">
            {scenes.map((scene, i) => (
              <Menu.Item key={i}>
                <Link route="scene" handle={scene}>
                  <div className="flex items-center justify-between bg-attention p-3">
                    <p className="truncate whitespace-nowrap text-sm">{scene}</p>
                    <CursorRight width={12} height={12} fill="black" />
                  </div>
                </Link>
              </Menu.Item>
            ))}
          </div>
        </Collapse>
        {/* <div>
          <Menu.Item>
            <Link route="category" handle="名入れ・刻印・プリント">
              <div className="flex justify-between bg-white px-4 py-3">
                <p className="text-[15px]">写真・名入れグッズ</p>
                <CursorRight width={12} height={12} fill="black" />
              </div>
            </Link>
          </Menu.Item>
        </div> */}
        <div>
          <Menu.Item>
            <Link route="features">
              <div className="flex justify-between bg-white px-4 py-3">
                <p className="text-[15px] font-bold">おすすめ特集</p>
                <CursorRight width={12} height={12} fill="black" />
              </div>
            </Link>
          </Menu.Item>
        </div>
        <div>
          <Menu.Item>
            <Link route="ranking">
              <div className="flex justify-between bg-white px-4 py-3">
                <p className="text-[15px] font-bold">ランキング</p>
                <CursorRight width={12} height={12} fill="black" />
              </div>
            </Link>
          </Menu.Item>
        </div>
        {/* <div>
          <Menu.Item>
            <Link route="home">
              <div className="flex justify-between bg-white px-4 py-3">
                <p className="text-[15px] font-bold">ペット動画＆ページ作成</p>
                <CursorRight width={12} height={12} fill="black" />
              </div>
            </Link>
          </Menu.Item>
        </div> */}
      </div>
      <div className="px-16 text-white">
        <div className="mb-4 flex items-end justify-center gap-4">
          <p className="text-2xl tracking-[1.44px]">CONTACT</p>
          <p className="font-nold text-[15px]">お問合せ</p>
        </div>
        {/* <div className="mb-4 flex justify-center">
          <p className="text-xs">
            電話受付時間： 平日<span className="font-outfit">9:00-18:00</span>
          </p>
        </div> */}
        <div className="grid grid-cols-2 gap-3">
          <Menu.Item>
            {/* TODO */}
            <a href="tel:0120188800" className="flex flex-col items-center gap-1 bg-link py-1">
              <Tel width={24} height={24} fill="white" />
              <p className="text-xs font-bold">電話する</p>
            </a>
          </Menu.Item>
          <Menu.Item>
            <a
              href="mailto:support@cocopet.jp"
              className="flex flex-col items-center gap-1 bg-link py-1"
            >
              <Mail width={24} height={24} fill="white" />
              <p className="text-xs font-bold">メールする</p>
            </a>
          </Menu.Item>
        </div>
      </div>
    </Menu.Items>
  </Transition>
);
